import type { MentionTarget } from "@serophin/shared";
import { type MarkdownClasses, renderMarkdown } from "../markdown";
import { linkMentions } from "./mentions";

type MarkdownVariant = "default" | "compact";

export type MarkdownSkin = {
  classes?: Partial<MarkdownClasses>;
  mentionChip?: string;
};

type MarkdownProps = {
  source: string;
  class?: string;
  variant?: MarkdownVariant;
  mentions?: MentionTarget[];
  skin?: MarkdownSkin;
};

const VARIANT_CLASSES: Record<MarkdownVariant, string> = {
  default: "",
  compact: "[&_p]:mb-1.5 [&_ul]:mb-1.5 [&_ol]:mb-1.5 [&_h1]:mt-3 [&_h2]:mt-3 [&_h3]:mt-2 [&_blockquote]:mb-1.5 [&_pre]:mb-1.5 [&_table]:mb-1.5",
};

export const Markdown = ({ source, class: className, variant = "default", mentions, skin }: MarkdownProps) => {
  const html = renderMarkdown(mentions ? linkMentions(source, mentions, skin?.mentionChip) : source, skin?.classes);
  const classes = `${VARIANT_CLASSES[variant]} ${className ?? ""}`.trim();
  return <div class={classes || undefined} dangerouslySetInnerHTML={{ __html: html }} />;
};
